module.exports = __webpack_public_path__ + "static/media/linkedin-icon-blue.7fda5b15.svg";